module.exports = __webpack_public_path__ + "img/honghe.45f1ea92.png";